import axios from 'axios';
import NProgress from 'nprogress';
import storejs from 'store';
import { Message } from 'element-ui'

var apiInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL_WX,
  timeout: 10000
  // headers: {'token': localStorage.getItem("token")}
});
var apiCloudInstance = axios.create({
  baseURL: process.env.VUE_APP_APICLOUD_URL_WX,
  timeout: 10000
  // headers: {'token': localStorage.getItem("token")}
});
let base =''
apiInstance.defaults.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.VUE_APP_APPKEY+"token");
export function cleanToken(){
  apiInstance.defaults.headers.common['Authorization'] = ''
  apiCloudInstance.defaults.headers.common['Authorization'] = ''
}
apiCloudInstance.defaults.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.VUE_APP_APPKEY+"token");

// export const requestLogin = params => { return axios.post(`${api}api/cms/user/login`, params).then(res => res.data); };
// export const requestLogin = params => { return axios.post(`${base}/login`, params).then(res => res.data); };
export const requestLogin = params => { return apiInstance.post(`api/cms/user/login`,  params); };

export const authJWT = () => { return apiInstance.post(`api/cms/user/authJWT`); };

export const getUserAccess = () => { return apiInstance.post(`api/cms/user/userAccessInfo`); };

export const getUserList = params => { return apiInstance.get(`api/cms/user/userListPage`, { params: params }); };

export const saveUserRole = params => { return apiInstance.post(`api/cms/user/saveUser`, params ); };

export const updateUserRole = params => { return apiInstance.post(`api/cms/user/updateUser`, params ); };

export const validationUsername = params => { return apiInstance.get(`api/cms/user/validationUsername`, { params: params }); };

export const getRoleList = () => { return apiInstance.get(`api/cms/rbac/roleList`); };

export const getRoleListPage = params => { return apiInstance.get(`api/cms/rbac/roleListPage`, { params: params }); };

export const saveRole = params => { return apiInstance.post(`api/cms/rbac/saveRole`, params ); };

export const updateRole = params => { return apiInstance.post(`api/cms/rbac/updateRole`, params ); };

export const roleDataAccessList = params => { return apiInstance.post(`api/cms/rbac/roleDataAccessList`, params ); };

export const queryListMenu = params => { return apiInstance.get(`api/cms/rbac/listMenu`, { params: params }); };

export const updateMenu = params => { return apiInstance.post(`api/cms/rbac/updateMenu`, params ); };
// export const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };

export const getUserListPage = params => { return axios.get(`${base}/user/listpage`, { params: params }); };

export const removeUser = params => { return axios.get(`${base}/user/remove`, { params: params }); };

export const batchRemoveUser = params => { return axios.get(`${base}/user/batchremove`, { params: params }); };


export const editUser = params => { return axios.get(`${base}/user/edit`, { params: params }); };

export const addUser = params => { return axios.get(`${base}/user/add`, { params: params }); };

// export const getRecommendIndex1 = params => { return apiInstance.post(`api/cms/carouselFigure/getRecommendIndex1`); };
export const getRecommendIndex1 = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/getRecommendIndex1`); };

// export const getRecommendIndex2 = params => { return apiInstance.post(`api/cms/carouselFigure/getRecommendIndex2`,params); };
export const getRecommendIndex2 = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/getRecommendIndex2`,params); };

// export const getRecommendList = params => { return apiInstance.post(`api/cms/carouselFigure/getRecommendList`,params); };
export const getRecommendList = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/getRecommendList`,params); };

// export const delRecommend = params => { return apiInstance.post(`api/cms/carouselFigure/delRecommend`,params); };
export const delRecommend = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/delRecommend`,params); };

// export const getNewsListPage = params => { return apiInstance.post(`api/cms/news/getNewsList`,  params); }; /*获取资讯列表*/
export const getNewsListPage = params => { return apiCloudInstance.post(`/api-cms/cms/news/getNewsList`,  params); }; /*获取资讯列表*/

// export const getConsultList = params => { return apiInstance.post(`api/cms/news/getConsultList`,  params); }; /*获取资讯分类*/
export const getConsultList = params => { return apiCloudInstance.post(`/api-cms/cms/news/getConsultList`,  params); }; /*获取资讯分类*/

// export const getDictProject = params => { return apiInstance.post(`api/cms/news/getDictProject`,  params); }; /*获取项目分类*/
export const getDictProject = params => { return apiCloudInstance.post(`/api-cms/cms/news/getDictProject`,  params); }; /*获取项目分类*/

// export const getDictNewsType = params => { return apiInstance.post(`api/cms/news/getDictNewsType`,  params); }; /*获取文章类型*/
export const getDictNewsType = params => { return apiCloudInstance.post(`/api-cms/cms/news/getDictNewsType`,  params); }; /*获取文章类型*/

// export const getDictSubject = params => { return apiInstance.post(`api/cms/news/getDictSubject`,  params); }; /*获取学科分类1*/
export const getDictSubject = params => { return apiCloudInstance.post(`/api-cms/cms/news/getDictSubject`,  params); }; /*获取学科分类1*/

// export const getSecondLoginPosition = params => { return apiInstance.get(`api/cms/news/getSecondLoginPosition`,  { params: params }); }; /*二级登陆页下拉数据*/
export const getSecondLoginPosition = params => { return apiInstance.get(`api/study/secondPage/getSecondLoginPosition`,  { params: params }); }; /*二级登陆页下拉数据*/

// export const addNewsInfo = params => { return apiInstance.post(`api/cms/news/addNews`,  params); }; /*添加资讯*/
export const addNewsInfo = params => { return apiCloudInstance.post(`/api-cms/cms/news/addNews`,  params); }; /*添加资讯*/

// export const delNewsInfo = params => { return apiInstance.post(`api/cms/news/delNewsInfo`,  params); }; /*删除资讯*/
export const delNewsInfo = params => { return apiCloudInstance.post(`/api-cms/cms/news/delNewsInfo`,  params); }; /*删除资讯*/

// export const validateNewsTitle = params => { return apiInstance.post(`api/cms/news/validateNewsTitle`,  params); }; /*验证资讯名称是否重复 用于添加资讯*/
export const validateNewsTitle = params => { return apiCloudInstance.post(`/api-cms/cms/news/validateNewsTitle`,  params); }; /*验证资讯名称是否重复 用于添加资讯*/

// export const editNewsInfo = params => { return apiInstance.post(`api/cms/news/editNews`,  params); }; /*修改资讯*/
export const editNewsInfo = params => { return apiCloudInstance.post(`/api-cms/cms/news/editNews`,  params); }; /*修改资讯*/


// export const getCompileNewsPage = params => { return apiInstance.post(`api/cms/compnews/getCompileNewsList`,  params); }; /*获取资讯列表*/
export const getCompileNewsPage = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/getCompileNewsList`,  params); }; /*获取资讯列表*/

/**
 * @description:搜索专家(医生)
 */
 export const doctorSearchDoctor = (params) => {
  return apiCloudInstance.get(`/api-study/v1/doctor/searchDoctor`, {params: params}).then(res => res.data);
};

export const addCompileNews = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/addCompileNews`,  params); }; /*添加资讯*/


// export const delCompileNews = params => { return apiInstance.post(`api/cms/compnews/delCompileNews`,  params); }; /*删除资讯*/
export const delCompileNews = params => { return apiCloudInstance.post(`//api-cms-cms/cms/compnews/delCompileNews`,  params); }; /*删除资讯*/

// export const vftelTitleName = params => { return apiInstance.post(`api/cms/compnews/vftelTitleName`,  params); }; /*验证资讯名称是否重复 用于添加资讯*/
export const vftelTitleName = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/vftelTitleName`,  params); }; /*验证资讯名称是否重复 用于添加资讯*/

// export const editCompileNews = params => { return apiInstance.post(`api/cms/compnews/editCompileNews`,  params); }; /*修改资讯*/
export const editCompileNews = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/editCompileNews`,  params); }; /*修改资讯*/

// export const batchDelCms = params => { return apiInstance.post(`api/cms/compnews/batchDelCms`,  params); }; /*批量删除资讯*/
export const batchDelCms = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/batchDelCms`,  params); }; /*批量删除资讯*/

// export const updateState = params => { return apiInstance.post(`api/cms/compnews/updateState`,  params); }; /*审核和取消资讯*/
export const updateState = params => { return apiCloudInstance.post(`/api-cms/cms/compnews/updateState`,  params); }; /*审核和取消资讯*/

// export const updateRecommend = params => { return apiInstance.post(`api/cms/carouselFigure/updateRecommend`,params); };
export const updateRecommend = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/updateRecommend`,params); };

// export const indexRecommend = params => { return apiInstance.post(`api/cms/carouselFigure/indexRecommend`,params); };
export const indexRecommend = params => { return apiCloudInstance.post(`/api-cms/cms/carouselFigure/indexRecommend`,params); };

/**************************************************************************问答功能相关begin **************************************************************/

/**************************************************************************黑词管理begin **************************************************************/

// export const getShieldingInfo = params => { return apiInstance.get(`api/comment/shielding/getShieldingInfo`, { params: params }); };
export const getShieldingInfo = params => { return apiCloudInstance.get(`/api-cms/v1/comments/shielding/getShieldingInfo`, { params: params }); };
// export const validateShieldingWords = params => { return apiInstance.get(`api/comment/shielding/validateShieldingWords`, { params: params }); };
export const validateShieldingWords = params => { return apiCloudInstance.get(`/api-cms/v1/comments/shielding/validateShieldingWords`, { params: params }); };

// export const updateShieldingInfo = params => { return apiInstance.post(`api/comment/shielding/updateShieldingInfo`,  params); }; /*编辑黑词*/
export const updateShieldingInfo = params => { return apiCloudInstance.post(`/api-cms/v1/comments/shielding/updateShieldingInfo`,  params); }; /*编辑黑词*/

/**************************************************************************黑词管理end **************************************************************/

// 评论列表
export const listComment = params => { return apiInstance.get(`api/comment/list`,  { params: params }); }; /*评论列表*/
export const deleteComment = params => { return apiInstance.post(`api/comment/update`,  params); }; /*删除评论*/
export const replayComment = params => { return apiInstance.post(`api/comment/replay/replay`,  params); }; /*管理员回复评论*/
export const replayList = params => { return apiInstance.get(`api/comment/replay/replayList`,   { params: params }); }; /*管理员回复评论列表*/
export const deleteReplay = params => { return apiInstance.post(`api/comment/replay/deleteReplay`,  params); }; /*删除管理员回复*/

// export const getQuestionList = params => { return apiInstance.get(`api/cms/question/getQuestionList`,  { params: params }); }; /*审核和取消资讯*/
export const getQuestionList = params => { return apiCloudInstance.get(`api-cms/cms/question/getQuestionList`,  { params: params }); }; /*审核和取消资讯*/
// export const deleteQuestion = params => { return apiInstance.post(`api/cms/question/deleteQuestion`,  params); }; /*删除问答*/
export const deleteQuestion = params => { return apiCloudInstance.post(`api-cms/cms/question/deleteQuestion`,  params); }; /*删除问答*/
// export const sendEmail = params => { return apiInstance.post(`api/cms/question/sendEmail`,  params); }; /*发送邮件并本地保存记录*/
export const sendEmail = params => { return apiCloudInstance.post(`api-cms/cms/question/sendEmail`,  params); }; /*发送邮件并本地保存记录*/
// export const auditQuestion = params => { return apiInstance.post(`api/cms/question/auditQuestion`,  params); }; /*审核取消审核的功能*/
export const auditQuestion = params => { return apiCloudInstance.post(`api-cms/cms/question/auditQuestion`,  params); }; /*审核取消审核的功能*/
// export const batchDelQuestion = params => { return apiInstance.post(`api/cms/question/batchDelQuestion`,  params); }; /*批量删除功能*/
export const batchDelQuestion = params => { return apiCloudInstance.post(`api-cms/cms/question/batchDelQuestion`,  params); }; /*批量删除功能*/


/**************************************************************************问答功能相关end **************************************************************/


// 加载拦截
apiInstance.interceptors.request.use(function (config) {
  // POST传参序列化
  // if(config.method  === 'post'){
  //   config.data = qs.stringify(config.data);
  // }
  // Do something before request is sent
  NProgress.start();
  //解决第一次登陆初始化实例没有token问题
  if(!apiInstance.defaults.headers.common['Authorization']||(apiInstance.defaults.headers.common['Authorization'].split('.')).length-1==0){
    config.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.VUE_APP_APPKEY+"token");
  }
  return config;
}, function (error) {
  // Do something with request error
  console.error(error)
  return Promise.reject(error);
});
// Add a response interceptor
apiInstance.interceptors.response.use(function (response) {
  // Do something with response data
  NProgress.done();
  if(response.status != 200){
    Message({
      message: '网络异常！',
      type: 'warning'
    });
  }
  return response;
}, function (error) {
  // Do something with response error
  console.error(error)
  return Promise.reject(error);
});

apiCloudInstance.interceptors.request.use(function (config) {
    NProgress.start();

    //解决第一次登陆初始化实例没有token问题
    if (!apiCloudInstance.defaults.headers.common['Authorization'] || (apiCloudInstance.defaults.headers.common['Authorization'].split('.')).length - 1 == 0) {
        config.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.VUE_APP_APPKEY + "token");
    }
    return config;
}, function (error) {
    NProgress.done();
    return Promise.reject(error);
});

apiCloudInstance.interceptors.response.use(function (response) {
    NProgress.done();
    if (response.data.code == 1) {
        Message.error(response.data.msg);
        return Promise.reject(response.data);
    }
    return response;
}, function (error) {
    console.error(error)
    return Promise.reject(error);
});


// 加载拦截
apiCloudInstance.interceptors.request.use(function (config) {
  // POST传参序列化
  // if(config.method  === 'post'){
  //   config.data = qs.stringify(config.data);
  // }
  // Do something before request is sent
  NProgress.start();
  //解决第一次登陆初始化实例没有token问题
  if(!apiCloudInstance.defaults.headers.common['Authorization']||(apiCloudInstance.defaults.headers.common['Authorization'].split('.')).length-1==0){
    config.headers.common['Authorization'] = 'Bearer ' + storejs.get(process.env.VUE_APP_APPKEY+"token");
  }
  return config;
}, function (error) {
  // Do something with request error
  console.error(error)
  return Promise.reject(error);
});
// Add a response interceptor
apiCloudInstance.interceptors.response.use(function (response) {
  // Do something with response data
  NProgress.done();
  if(response.status != 200){
    Message({
      message: '网络异常！',
      type: 'warning'
    });
  }
  return response;
}, function (error) {
  // Do something with response error
  console.error(error)
  return Promise.reject(error);
});

// 加载拦截
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  NProgress.start();
  return config;
}, function (error) {
  // Do something with request error
  console.error(error)
  return Promise.reject(error);
});
// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  NProgress.done();
  return response;
}, function (error) {
  // Do something with response error
  console.error(error)
  return Promise.reject(error);
});
